import script from "./AgentInbox.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentInbox.vue?vue&type=script&setup=true&lang=js"

import "./AgentInbox.vue?vue&type=style&index=0&id=da35404e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da35404e"]])

export default __exports__